import React from 'react';
import Row
			 from 'reactstrap/es/Row';
import Card
			 from 'reactstrap/es/Card';
import CardHeader
			 from 'reactstrap/es/CardHeader';
import CardBody
			 from 'reactstrap/es/CardBody';
import Input
			 from 'reactstrap/es/Input';
import Col
			 from 'reactstrap/es/Col';
import Label
			 from 'reactstrap/es/Label';
import Button
			 from 'reactstrap/es/Button';
import SalesArea
			 from '../SalesArea/SalesArea';

class PizzaName extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			config: this.props.config,
		}
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.config !== nextProps.config) {
			return { config: nextProps.config };
		}

		return null;
	}

	onNameChange = (event) => {
		if (this.props.onConfigChange) {
			var {config} = this.state;
			config.Name = event.target.value;
			this.props.onConfigChange(config);
		}
	}

	onSaveClick = () => {
		if (this.props.onSaveHandler) {
			this.props.onSaveHandler();
		}
	}

	onDeleteClick = () => {
		if (this.props.onDeleteHandler) {
			this.props.onDeleteHandler();
		}
	}

	onSelectSalesArea = (salesArea) => {
		if (this.props.onSalesAreaHandler) {
			this.props.onSalesAreaHandler(salesArea);
		}
	}

	render() {
		const {config} = this.state;
		return (
			<>
				<div className={`pizza-name`}>
					<Row>
						<i className={`fa fa-trash`} onClick={this.onDeleteClick}></i>
						<Col xs={12} md={6}>
							<Label for={`name`}>Config Name</Label><Input name={`name`} onChange={this.onNameChange} value={config.Name} />
						</Col>
						<Col xs={12} md={6}>
							<SalesArea id={config.SalesAreaID} onSelectHandler={this.onSelectSalesArea} />
						</Col>
					</Row>
					<Row>
						<Col xs={12} md={6}>
							<Button onClick={this.onSaveClick}>Save Steps/Configuration</Button>
						</Col>
					</Row>
				</div>
			</>
		)
	}
}

export default PizzaName;
